import { Request } from '../../../../generic/v2/request/request';
import { CommunicationsRequestNameType } from '../../../communications-request-name';

export abstract class CommunicationsRequest extends Request<CommunicationsRequestNameType> {}
